// Estilos de index.html
export const QuantumConfig = {
    titulo: window.murphyQuantum.titulo,
    logo: window.murphyQuantum.logo,
    fondo: window.murphyQuantum.fondo,
    colorPrimario: window.murphyQuantum.colorPrimario,
    colorSecundario: window.murphyQuantum.colorSecundario,
}


// Funciones para mandar los valores
export const getConfig = (nombreVariable) => {
    return QuantumConfig[nombreVariable];
}

const config = {
    urlApi: window.location.protocol + "//" + window.location.hostname + (window.location.port ? ':' + window.location.port : ''),
    passEncrypt: process.env.REACT_APP_PASS_ENCRIPT
};

export default config;